// extracted by mini-css-extract-plugin
module.exports = {"create":"styles_create__2_axY","subtitle":"styles_subtitle__3pjPU","content":"styles_content__12Ilq"};